import { motion } from "framer-motion";
import Contact from "../Components/Contact";
import FAQ from "../Components/FAQ";
import SEO from "../Components/SEO";

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const contactSchema = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "name": "Contact ElectroPlating Lebanon",
  "description": "Get in touch with ElectroPlating Lebanon for quotes, inquiries, or to discuss your metal finishing project.",
  "url": "https://www.electroplating-lb.com/contact",
  "mainEntity": {
    "@type": "LocalBusiness",
    "name": "ElectroPlating Lebanon",
    "telephone": "+961-03-518-323",
    "email": "electroplatinglb@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "LB",
      "addressRegion": "Lebanon"
    }
  }
};

const ContactPage = () => {
  return (
    <main>
      <SEO
        title="Contact Us"
        description="Contact ElectroPlating Lebanon for quotes and inquiries. Reach us by phone at +961 03 518 323 or email electroplatinglb@gmail.com. Get expert metal finishing services today."
        keywords="contact electroplating Lebanon, electroplating quote, metal finishing inquiry, Lebanon electroplating phone, electroplating email"
        canonicalUrl="/contact"
        structuredData={contactSchema}
      />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInUp}
      >
        <Contact />
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInUp}
      >
        <FAQ />
      </motion.div>
    </main>
  );
};

export default ContactPage;
